export const referringProviderAction = {
  setShowReferringProviderModal: (state, action) => {
    state.showReferringProviderModal = action.payload;
  },
  setIsProcessing: (state, action) => {
    state.isProcessing = action.payload;
  },
  setIsUpdateOperation: (state, action) => {
    state.isUpdateOperation = action.payload;
  },
  setSelectedReferringProvider: (state, action) => {
    state.selectedReferringProvider = action.payload;
  },
  setShowDeleteConfirmationModal: (state, action) => {
    state.showDeleteConfirmationModal = action.payload;
  },
};
